module.exports = __webpack_public_path__ + "img/c.2e18ba7a.jpg";